module.exports = __webpack_public_path__ + "img/comments-selected.0e245e55.svg";